// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.neQmbSbhmHfFiaktxL8A {
    padding-top: 16px;
    padding-bottom: 16px
}
.hi_MSQOWl5twXFb7JMC_ {
    margin-bottom: 14px
}
.m8l6VuBz2jBI9XXcQsHy {
    border-radius: 5px;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 1.5rem
}
.xDJVNmvZ0RYjoLM78yos {
    margin-bottom: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.75rem
}
.saT_vFpxiCADxRhfs997 {
    height: 38px !important;
    width: 18rem;
    border-radius: 5px;
    --tw-text-opacity: 1;
    color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}

.fRJGTuysHYReWBTq0xwy {
    margin-top: 1rem;
    display: flex;
    height: 84px;
    align-items: center;
    border-radius: 5px;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
    --tw-shadow: 0px 0px 40px 0px #0378D117 !important;
    --tw-shadow-colored: 0px 0px 40px 0px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important
}
.AuxIvZCb3PBGJPKq3kQy {
    margin-left: 0.75rem;
    display: flex;
    height: 55px;
    width: 55px;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    --tw-bg-opacity: 1;
    background-color: rgb(230 244 240 / var(--tw-bg-opacity, 1))
}

.PaVG_1G2ibrUI8hm3mJr {
    margin-left: 0.75rem;
    display: flex;
    height: 55px;
    width: 55px;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    --tw-bg-opacity: 1;
    background-color: rgb(230 242 250 / var(--tw-bg-opacity, 1))
}

.tEHuuMxby4uxuOV9wkzD {
    height: 22px;
    width: 21px
}

.sQIgYWVtxIkYi7llk45P {
    height: 25px;
    width: 25px
}
.h6TZOfOrAdd7ssLO8B8i {
    width: 170px;
    font-family: Noto Sans;
    font-size: 16px;
    font-weight: 600;
    --tw-text-opacity: 1;
    color: rgb(94 94 94 / var(--tw-text-opacity, 1))
}

.IqnsfO7dQj8sGcosGmSW {
    width: 200px;
    font-family: Noto Sans;
    font-size: 14px;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(94 94 94 / var(--tw-text-opacity, 1))
}
.OTSRAOjwmjcRMUtOEBRK {
    margin-left: 1.25rem;
    font-family: Noto Sans;
    font-size: 12px;
    font-weight: 400;
    --tw-text-opacity: 1;
    color: rgb(141 141 141 / var(--tw-text-opacity, 1))
}
.Shlw1wB94lvMtkGT8U7A {
    display: flex;
    width: 120px;
    align-items: center;
    gap: 0.25rem;
    white-space: nowrap;
    font-family: Noto Sans;
    font-size: 16px;
    font-weight: 600;
    --tw-text-opacity: 1;
    color: rgb(94 94 94 / var(--tw-text-opacity, 1))
}

.lT4GFY05KzPgHJpUt8gS {
    cursor: pointer;
    font-size: 14px;
    --tw-text-opacity: 1;
    color: rgb(141 141 141 / var(--tw-text-opacity, 1))
}

.lT4GFY05KzPgHJpUt8gS:hover {
    --tw-text-opacity: 1;
    color: rgb(3 120 209 / var(--tw-text-opacity, 1))
}
.Ewi2Ox0auAjAwsosBLqQ {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between
}

.agZhYG7Lg9uS_p82TCbU {
    display: flex;
    align-items: center;
    gap: 1rem
}

._XBnbKWT_aRTAzq7iynB {
    margin-right: 0.75rem;
    display: flex;
    gap: 1.5rem
}

.VTNCJiKmQwvsQy3brxLr {
    display: flex;
    height: 24px;
    width: 86px;
    align-items: center;
    justify-content: center;
    border-radius: 9999px;
    font-family: Noto Sans;
    font-size: 12px;
    font-weight: 500
}

.RZR6eyYuzrpKkveFWjH5 {
    --tw-bg-opacity: 1;
    background-color: rgb(1 144 101 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

.pauLXc0RoxifGcqIp7UM {
    --tw-bg-opacity: 1;
    background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(254 226 226 / var(--tw-text-opacity, 1))
}

.QISdqnnwhQliLG5VhSr0 {
    --tw-bg-opacity: 1;
    background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(254 249 195 / var(--tw-text-opacity, 1))
}

.FjmWLESzkE_8lVjiYfgf {
    height: 38px;
    width: 120px;
    --tw-border-opacity: 1;
    border-color: rgb(0 130 202 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    --tw-text-opacity: 1;
    color: rgb(0 130 202 / var(--tw-text-opacity, 1))
}

.FjmWLESzkE_8lVjiYfgf:hover {
    --tw-border-opacity: 1 !important;
    border-color: rgb(0 130 202 / var(--tw-border-opacity, 1)) !important;
    --tw-bg-opacity: 1 !important;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
    --tw-text-opacity: 1 !important;
    color: rgb(0 130 202 / var(--tw-text-opacity, 1)) !important
}

.kH0bzQwJt_hWKNsCH6wL {
    margin-top: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center
}

.k2g54SW40JXgb9jhnQK4 {
    height: 38px !important;
    border-radius: 5px
}

.lt18qiFwcToT8v4HLXlD {
    width: 200px;
    cursor: pointer;
    --tw-text-opacity: 1;
    color: rgb(3 120 209 / var(--tw-text-opacity, 1));
    display: flex;
    justify-content: center;
    gap: 1rem;
    font-family: Noto Sans;
    font-size: 12px;
    font-weight: 700;
    text-decoration-line: underline
}
.kkOIGToJPsrBWTim9tWy {
    width: 200px
}
`, "",{"version":3,"sources":["webpack://./src/pages/Transaction/Transaction.module.css"],"names":[],"mappings":"AACE;IAAA,iBAAgB;IAAhB;AAAgB;AAGhB;IAAA;AAAgB;AAGhB;IAAA,kBAAiC;IAAjC,kBAAiC;IAAjC,4DAAiC;IAAjC;AAAiC;AAGjC;IAAA,qBAA+C;IAA/C,aAA+C;IAA/C,mBAA+C;IAA/C,yBAA+C;IAA/C;AAA+C;AAG/C;IAAA,uBAAkD;IAAlD,YAAkD;IAAlD,kBAAkD;IAAlD,oBAAkD;IAAlD;AAAkD;;AAIlD;IAAA,gBAA6G;IAA7G,aAA6G;IAA7G,YAA6G;IAA7G,mBAA6G;IAA7G,kBAA6G;IAA7G,iBAA6G;IAA7G,sBAA6G;IAA7G,4DAA6G;IAA7G,kDAA6G;IAA7G,uEAA6G;IAA7G;AAA6G;AAG7G;IAAA,oBAA2F;IAA3F,aAA2F;IAA3F,YAA2F;IAA3F,WAA2F;IAA3F,mBAA2F;IAA3F,uBAA2F;IAA3F,kBAA2F;IAA3F,kBAA2F;IAA3F;AAA2F;;AAI3F;IAAA,oBAAkG;IAAlG,aAAkG;IAAlG,YAAkG;IAAlG,WAAkG;IAAlG,mBAAkG;IAAlG,uBAAkG;IAAlG,kBAAkG;IAAlG,kBAAkG;IAAlG;AAAkG;;AAIlG;IAAA,YAAwB;IAAxB;AAAwB;;AAIxB;IAAA,YAAwB;IAAxB;AAAwB;AAGxB;IAAA,YAA6D;IAA7D,sBAA6D;IAA7D,eAA6D;IAA7D,gBAA6D;IAA7D,oBAA6D;IAA7D;AAA6D;;AAI7D;IAAA,YAA+E;IAA/E,sBAA+E;IAA/E,eAA+E;IAA/E,gBAA+E;IAA/E,oBAA+E;IAA/E;AAA+E;AAG/E;IAAA,oBAAwE;IAAxE,sBAAwE;IAAxE,eAAwE;IAAxE,gBAAwE;IAAxE,oBAAwE;IAAxE;AAAwE;AAGxE;IAAA,aAAuG;IAAvG,YAAuG;IAAvG,mBAAuG;IAAvG,YAAuG;IAAvG,mBAAuG;IAAvG,sBAAuG;IAAvG,eAAuG;IAAvG,gBAAuG;IAAvG,oBAAuG;IAAvG;AAAuG;;AAIvG;IAAA,eAA+C;IAA/C,eAA+C;IAA/C,oBAA+C;IAA/C;AAA+C;;AAI/C;IAAA,oBAAmB;IAAnB;AAAmB;AAGnB;IAAA,aAA+C;IAA/C,WAA+C;IAA/C,mBAA+C;IAA/C;AAA+C;;AAI/C;IAAA,aAA8B;IAA9B,mBAA8B;IAA9B;AAA8B;;AAI9B;IAAA,qBAAsB;IAAtB,aAAsB;IAAtB;AAAsB;;AAItB;IAAA,aAAsH;IAAtH,YAAsH;IAAtH,WAAsH;IAAtH,mBAAsH;IAAtH,uBAAsH;IAAtH,qBAAsH;IAAtH,sBAAsH;IAAtH,eAAsH;IAAtH;AAAsH;;AAItH;IAAA,kBAAgC;IAAhC,0DAAgC;IAAhC,oBAAgC;IAAhC;AAAgC;;AAIhC;IAAA,kBAA8B;IAA9B,0DAA8B;IAA9B,oBAA8B;IAA9B;AAA8B;;AAI9B;IAAA,kBAAoC;IAApC,0DAAoC;IAApC,oBAAoC;IAApC;AAAoC;;AAIpC;IAAA,YAAkE;IAAlE,YAAkE;IAAlE,sBAAkE;IAAlE,0DAAkE;IAAlE,kBAAkE;IAAlE,4DAAkE;IAAlE,oBAAkE;IAAlE;AAAkE;;AAIlE;IAAA,iCAAkD;IAAlD,qEAAkD;IAAlD,6BAAkD;IAAlD,uEAAkD;IAAlD,+BAAkD;IAAlD;AAAkD;;AAIlD;IAAA,kBAA6C;IAA7C,aAA6C;IAA7C,mBAA6C;IAA7C;AAA6C;;AAI7C;IAAA,uBAA8B;IAA9B;AAA8B;;AAI9B;IAAA,YAAqF;IAArF,eAAqF;IAArF,oBAAqF;IAArF,iDAAqF;IAGrF,aAA2E;IAA3E,uBAA2E;IAA3E,SAA2E;IAA3E,sBAA2E;IAA3E,eAA2E;IAA3E,gBAA2E;IAA3E;AAHqF;AAMrF;IAAA;AAAgB","sourcesContent":[".container {\n  @apply py-[16px];\n}\n.customBreadCrumbs {\n  @apply mb-[14px];\n}\n.mainContainer {\n  @apply bg-white rounded-[5px] p-6;\n}\n.tenantRightActions {\n  @apply flex items-center justify-end gap-3 mb-6;\n}\n.searchInput {\n  @apply rounded-[5px]  w-72 !h-[38px] text-gray-500;\n}\n\n.card {\n  @apply h-[84px] border border-white !shadow-[0px_0px_40px_0px_#0378D117] mt-4 flex items-center rounded-[5px];\n}\n.iconReloadDiv {\n  @apply bg-success-100 h-[55px] w-[55px] rounded-[5px] ml-3 flex justify-center items-center;\n}\n\n.iconArrowDiv {\n  @apply bg-hoverMenuItemColor h-[55px] w-[55px] rounded-[5px] ml-3 flex justify-center items-center;\n}\n\n.iconSize {\n  @apply w-[21px] h-[22px];\n}\n\n.redemptionIcon {\n  @apply w-[25px] h-[25px];\n}\n.type {\n  @apply font-h4 text-button text-gray-600 font-inter w-[170px];\n}\n\n.itemType {\n  @apply w-[200px] text-dashboardMain font-dashboardMain font-inter text-gray-600;\n}\n.date {\n  @apply font-dashboardSub text-dashboardSub font-inter text-gray-400 ml-5;\n}\n.amount {\n  @apply font-h4 text-button text-gray-600 font-inter w-[120px] flex items-center gap-1 whitespace-nowrap;\n}\n\n.infoIcon {\n  @apply text-gray-400 cursor-pointer text-[14px];\n}\n\n.infoIcon:hover {\n  @apply text-primary;\n}\n.cardFullContainer {\n  @apply flex items-center justify-between w-full;\n}\n\n.leftSideItems {\n  @apply flex gap-4 items-center;\n}\n\n.rightSideItems {\n  @apply flex mr-3 gap-6;\n}\n\n.status {\n  @apply rounded-full w-[86px] h-[24px] flex items-center justify-center font-inter text-dashboardSub font-dashboardMain;\n}\n\n.statusSuccess {\n  @apply bg-success-200 text-white;\n}\n\n.statusFailed {\n  @apply text-red-100 bg-red-600;\n}\n\n.statusPending {\n  @apply text-yellow-100 bg-yellow-500;\n}\n\n.clearButton {\n  @apply bg-white text-secondary border-secondary w-[120px] h-[38px];\n}\n\n.clearButton:hover {\n  @apply !bg-white !text-secondary !border-secondary;\n}\n\n.button {\n  @apply flex justify-center items-center mt-10;\n}\n\n.formTimePicker {\n  @apply !h-[38px] rounded-[5px];\n}\n\n.actionItem {\n  @apply text-primary font-h2 text-[12px] underline cursor-pointer font-inter w-[200px];\n}\n.actionItem {\n  @apply flex gap-4 justify-center text-[12px] font-inter font-bold underline;\n}\n.actionPlaceholder {\n  @apply w-[200px];\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `neQmbSbhmHfFiaktxL8A`,
	"customBreadCrumbs": `hi_MSQOWl5twXFb7JMC_`,
	"mainContainer": `m8l6VuBz2jBI9XXcQsHy`,
	"tenantRightActions": `xDJVNmvZ0RYjoLM78yos`,
	"searchInput": `saT_vFpxiCADxRhfs997`,
	"card": `fRJGTuysHYReWBTq0xwy`,
	"iconReloadDiv": `AuxIvZCb3PBGJPKq3kQy`,
	"iconArrowDiv": `PaVG_1G2ibrUI8hm3mJr`,
	"iconSize": `tEHuuMxby4uxuOV9wkzD`,
	"redemptionIcon": `sQIgYWVtxIkYi7llk45P`,
	"type": `h6TZOfOrAdd7ssLO8B8i`,
	"itemType": `IqnsfO7dQj8sGcosGmSW`,
	"date": `OTSRAOjwmjcRMUtOEBRK`,
	"amount": `Shlw1wB94lvMtkGT8U7A`,
	"infoIcon": `lT4GFY05KzPgHJpUt8gS`,
	"cardFullContainer": `Ewi2Ox0auAjAwsosBLqQ`,
	"leftSideItems": `agZhYG7Lg9uS_p82TCbU`,
	"rightSideItems": `_XBnbKWT_aRTAzq7iynB`,
	"status": `VTNCJiKmQwvsQy3brxLr`,
	"statusSuccess": `RZR6eyYuzrpKkveFWjH5`,
	"statusFailed": `pauLXc0RoxifGcqIp7UM`,
	"statusPending": `QISdqnnwhQliLG5VhSr0`,
	"clearButton": `FjmWLESzkE_8lVjiYfgf`,
	"button": `kH0bzQwJt_hWKNsCH6wL`,
	"formTimePicker": `k2g54SW40JXgb9jhnQK4`,
	"actionItem": `lt18qiFwcToT8v4HLXlD`,
	"actionPlaceholder": `kkOIGToJPsrBWTim9tWy`
};
export default ___CSS_LOADER_EXPORT___;
